import { Box } from "@mui/material";
import { Instagram } from "iconsax-react";
import { memo, useState } from "react";

import type { InstagramAvatarProps } from "./InstagramAvatar.types";
import * as styles from "./InstagramAvatar.styles";

export type { InstagramAvatarProps } from "./InstagramAvatar.types";

export const InstagramAvatar = memo(function InstagramAvatar({
  src,
  alt,
  size = 64,
}: InstagramAvatarProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const showImage = Boolean(src) && failedSrc !== src;

  return (
    <Box sx={styles.ring(size)}>
      <Box sx={styles.inner}>
        {showImage ? (
          <Box
            component="img"
            src={src}
            alt={alt}
            referrerPolicy="no-referrer"
            onError={() => setFailedSrc(src ?? null)}
            sx={styles.image}
          />
        ) : (
          <Box sx={styles.fallback}>
            <Instagram size={size * 0.42} variant="Bold" color="currentColor" />
          </Box>
        )}
      </Box>
    </Box>
  );
});
